export default function table($element) {
    class tmp_table_widget extends elementorModules.frontend.handlers.Base {
        getDefaultSettings() {
            return {
                selectors: {
                    table_container: ".tmp-table-container",
                    table: ".tmp-table",
                    row: ".tmp-table-row-js",
                    cell: ".tmp-table-cell-js",
                    js_hidden: ".tmp-table-mobile-hidden",
                    navigation_item: ".tmp-table-navigation-item",
                },
            };
        }

        getDefaultElements() {
            const w = this;
            const selectors = w.getSettings("selectors");
            return {
                $table: w.$element.find(selectors.table),
                $table_container: w.$element.find(selectors.table_container),
            };
        }

        bindEvents() {
            const w = this;
            const selectors = w.getSettings("selectors");
            w.$element.on("click", selectors.navigation_item, { w: w }, w.onNavigationClick);
        }

        onNavigationClick(e) {
            const w = e.data.w;
            const settings = w.getSettings();
            const selectors = settings.selectors;
            const t = jQuery(this);
            const index = t.index() + 1;
            const loading_id = tmp.loading(w.elements.$table_container);
            setTimeout(function () {
                tmp.loading_remove(loading_id);
                w.hideColumns(index);
            }, 100);
        }

        hideColumns(index) {
            const w = this;
            const settings = w.getSettings();
            const selectors = settings.selectors;
            w.elements.$table.find(selectors.row).each(function () {
                const t_row = jQuery(this);
                t_row.find(selectors.cell).each(function () {
                    const t_cell = jQuery(this);
                    if (t_cell.index() > 0) {
                        if (!t_cell.hasClass("tmp-table-mobile-hidden")) {
                            t_cell.addClass("tmp-table-mobile-hidden");
                        }
                        if (t_cell.index() === index) {
                            t_cell.removeClass("tmp-table-mobile-hidden");
                        }
                    }
                });
            });
        }
    }

    elementorFrontend.elementsHandler.addHandler(tmp_table_widget, {
        $element,
    });
}
